import { render } from "./GeneralPageView.vue?vue&type=template&id=f8e766da&scoped=true"
import script from "./GeneralPageView.vue?vue&type=script&lang=js"
export * from "./GeneralPageView.vue?vue&type=script&lang=js"

import "./GeneralPageView.vue?vue&type=style&index=0&id=f8e766da&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8e766da"]])

export default __exports__